module.exports = __webpack_public_path__ + "img/UG.48df9249.svg";